import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import { Devices, ScreenSizes, ImageTypes } from '../common/Constants';
import Classes from '../common/Classes';
import ProducerImage from '../common/producer/ProducerImage';


const ProducerDetailsImage = ({
  src, alt, defaultArtistLogoUrl, defaultArtistLogoMobileUrl,
  isRounded, producerId, tag
}) => (
  <div className={Classes.producerImageContainer}>
    <MediaQuery minWidth={1199}>
      <ProducerImage
        deviceType={Devices.desktop}
        imageSize={`${ScreenSizes.large}-${ImageTypes.producerDetails}`}
        producerId={producerId}
        src={src}
        alt={alt}
        isRounded={isRounded}
        tag={tag}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ProducerImage
        deviceType={Devices.desktop}
        imageSize={`${ScreenSizes.small}-${ImageTypes.producerDetails}`}
        producerId={producerId}
        src={src}
        alt={alt}
        isRounded={isRounded}
        tag={tag}
        defaultArtistLogoUrl={defaultArtistLogoUrl}
      />
    </MediaQuery>
    <MediaQuery maxWidth={991}>
      <ProducerImage
        deviceType={Devices.mobile}
        imageSize={`${ScreenSizes.large}-${ImageTypes.producerDetails}`}
        producerId={producerId}
        src={src}
        alt={alt}
        isRounded={isRounded}
        tag={tag}
        defaultArtistLogoUrl={defaultArtistLogoMobileUrl}
      />
    </MediaQuery>
  </div>);


ProducerDetailsImage.propTypes = {
  src: PropTypes.string,
  defaultArtistLogoUrl: PropTypes.string.isRequired,
  defaultArtistLogoMobileUrl: PropTypes.string.isRequired,
  alt: PropTypes.string,
  producerId: PropTypes.string,
  tag: PropTypes.string,
  isRounded: PropTypes.bool
};

export default ProducerDetailsImage;
